// Mock data for simmbedi.co personal branding website
export const personalInfo = {
  name: "Simm Bedi",
  title: "Personal Brand Strategist & Content Creator",
  brand: "simmbedi.co",
  tagline: "Elevating brands' online presence through strategic content creation and authentic storytelling",
  bio: "Passionate, results-driven creative professional with 3+ years of content creation experience. I help businesses and personal brands achieve significant growth through strategic social media management, compelling UGC content, and collaborative partnerships.",
  contact: {
    phone: "+1 437-429-2019",
    email: "simmbedi.sb@gmail.com",
    socials: {
      instagram: "@simmbedi",
      linkedin: "simm-bedi",
      tiktok: "@simmbedi"
    }
  }
};

export const services = [
  {
    id: 1,
    title: "Personal Brand Strategy",
    description: "Transform your vision into a powerful personal brand that resonates with your target audience and drives results.",
    features: ["Brand positioning & messaging", "Content pillars development", "Visual identity guidance", "Competitor analysis"]
  },
  {
    id: 2,
    title: "Social Media Strategy",
    description: "Data-driven social media strategies that build community, boost engagement, and convert followers into customers.",
    features: ["Platform optimization", "Content calendar creation", "Community management", "Performance analytics"]
  },
  {
    id: 3,
    title: "UGC & Content Creation",
    description: "Authentic, high-quality user-generated content that creates genuine connections between brands and audiences.",
    features: ["UGC video creation", "Product photography", "Authentic storytelling", "Brand-aligned content"]
  },
  {
    id: 4,
    title: "Consulting & Strategy",
    description: "Expert guidance to accelerate your brand growth with actionable strategies and proven methodologies.",
    features: ["1-on-1 strategy sessions", "Growth audits", "Campaign planning", "Influencer collaboration"]
  },
  {
    id: 5,
    title: "Video Editing & Production",
    description: "Professional video editing services that bring your content to life with engaging visuals and storytelling.",
    features: ["Short-form video editing", "Brand video production", "Content optimization", "Multi-platform formatting"]
  },
  {
    id: 6,
    title: "Partnership & Collaboration",
    description: "Strategic partnerships and collaborations that expand your reach and create meaningful brand connections.",
    features: ["Influencer partnerships", "Brand collaborations", "Creator program development", "Cross-promotion strategies"]
  }
];

export const portfolioProjects = [
  {
    id: 1,
    title: "Jill Yoga Brand",
    category: "Wellness & Lifestyle",
    challenge: "Inconsistent views and lack of creative, engaging videos for the yoga community.",
    solution: "Dynamic content strategy with short-form trending videos, influencer collaborations, and high-quality themed content production.",
    results: [
      "5x increase in video views in 3 months",
      "Consistent engagement & brand visibility",
      "Strengthened community through creator content",
      "Enhanced brand authority in wellness space"
    ],
    highlight: "5x Views Growth",
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&h=400&fit=crop&crop=center",
    caseStudyLink: "https://vibewithsimm.my.canva.site/daghmugxxpi"
  },
  {
    id: 2,
    title: "Squid Media", 
    category: "Digital Marketing Agency",
    challenge: "Needed to establish stronger online presence and showcase their creative capabilities to potential clients.",
    solution: "Developed comprehensive content strategy focusing on behind-the-scenes content, client success stories, and creative showcases.",
    results: [
      "Increased brand awareness and recognition",
      "Enhanced client engagement and inquiries", 
      "Strengthened position as creative agency",
      "Improved social media presence and authority"
    ],
    highlight: "Enhanced Brand Presence",
    image: "https://customer-assets.emergentagent.com/job_identity-forge-17/artifacts/7r85qpm8_Screenshot%202025-10-09%20at%205.23.24%E2%80%AFPM.png",
    caseStudyLink: "https://vibewithsimm.my.canva.site/daghmugxxpi"
  }
];

export const personalBrandSuccess = [
  {
    id: 1,
    name: "Sahas Chopra",
    role: "Digital Creator",
    challenge: "Needed niche positioning and audience growth in competitive digital space.",
    solution: "Introduced 'Content That Makes You Smarter' strategy, 2x daily posting, thought-provoking content focus.",
    result: "Grew from 6K to 400K followers in 6 months",
    image: "https://customer-assets.emergentagent.com/job_identity-forge-17/artifacts/ey8kf6el_1706396617320.jpeg"
  },
  {
    id: 2,
    name: "VibeWithSimm",
    role: "Personal Brand", 
    challenge: "Building authentic personal brand presence while showcasing UGC expertise and connecting with target audience.",
    solution: "Developed consistent brand voice, showcased behind-the-scenes content creation process, and built community through authentic storytelling.",
    result: "Established strong personal brand authority in UGC space",
    image: "https://customer-assets.emergentagent.com/job_identity-forge-17/artifacts/zoq5xe6t_WhatsApp%20Image%202025-09-30%20at%207.04.06%E2%80%AFPM%20%281%29.jpeg"
  },
  {
    id: 3,
    name: "WitsType.ai",
    role: "AI Content Platform",
    challenge: "Needed to establish thought leadership in AI content space while building trust with content creators and businesses.",
    solution: "Created educational content strategy, shared AI insights, and showcased platform capabilities through authentic use cases.",
    result: "Built strong brand recognition and increased user acquisition",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=150&h=150&fit=crop&crop=center"
  }
];

export const testimonials = [
  {
    id: 1,
    text: "We loved working with you... we will definitely reach out when we are needing more content.",
    client: "Brand Partner",
    company: "Consumer Brand"
  },
  {
    id: 2,
    text: "Product shots looks so aesthetic... we love it and are so excited to use it on our end! Thank you, thank you!!",
    client: "Marketing Manager",
    company: "Beauty Brand"
  },
  {
    id: 3,
    text: "Hi Simm, Big thanks for the video you did for last campaign! It was amazing! Can you make another one with that same editing style?",
    client: "Creative Director",
    company: "Fashion Brand"
  },
  {
    id: 4,
    text: "So happy we collaborated! You nailed it... everything looked great and was super timely!",
    client: "Founder",
    company: "Wellness Brand"
  },
  {
    id: 5,
    text: "Thank you for sending the video. Everything looks amazing! Your work is always spot on.",
    client: "Content Manager",
    company: "Tech Startup"
  }
];

export const skills = {
  technical: [
    "CapCut (Video Editing)",
    "Canva (Designing)", 
    "Hootsuite & Later",
    "Monday.com & Asana"
  ],
  marketing: [
    "Social Media Management",
    "Campaign Strategy & Execution",
    "Platform Optimization",
    "Community Engagement",
    "Influencer Collaboration"
  ],
  creative: [
    "Content Creation",
    "Scripting & Proofreading",
    "Photography",
    "Video Editing",
    "Brand Campaign Planning"
  ],
  soft: [
    "Creativity & Innovation",
    "Problem-Solving",
    "Communication & Collaboration",
    "Time Management",
    "Attention to Detail"
  ]
};

export const brandPartners = [
  "Faces Canada", "LAKMÉ", "BIODERMA", "Amazon", "Coach", "Anua"
];

export const ugcCategories = [
  {
    id: 1,
    name: "Beauty & Makeup",
    description: "Authentic makeup tutorials, product reviews, and beauty content",
    sampleContent: ["Perfect blush & highlight demonstrations", "Skincare routines", "Product comparisons"]
  },
  {
    id: 2,
    name: "Unboxing & Reviews",
    description: "Engaging unboxing experiences and honest product reviews",
    sampleContent: ["Tech product unboxings", "Beauty product reveals", "Fashion hauls"]
  },
  {
    id: 3,
    name: "Lifestyle & Vlogs",
    description: "Day-in-the-life content and lifestyle storytelling",
    sampleContent: ["Morning routines", "Social gatherings", "Behind-the-scenes content"]
  },
  {
    id: 4,
    name: "Fashion & Styling",
    description: "Outfit inspiration and styling tips",
    sampleContent: ["Outfit ideas", "Styling tutorials", "Fashion trends"]
  }
];